function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.77236 13.0006C8.77236 15.3118 10.6642 17.1922 13 17.1922C15.3252 17.1922 17.2171 15.3118 17.2171 13.0006C17.2171 10.679 15.3252 8.79862 13 8.79862C10.6642 8.79862 8.77236 10.679 8.77236 13.0006ZM19.2146 6.55055C21.0642 7.97924 22.639 10.0697 23.7699 12.6855C23.8545 12.8851 23.8545 13.1162 23.7699 13.3053C21.5081 18.5368 17.4813 21.6673 13 21.6673H12.9894C8.5187 21.6673 4.49187 18.5368 2.23009 13.3053C2.14553 13.1162 2.14553 12.8851 2.23009 12.6855C4.49187 7.45398 8.5187 4.33398 12.9894 4.33398H13C15.2407 4.33398 17.365 5.11136 19.2146 6.55055ZM13.0013 15.6142C14.4492 15.6142 15.633 14.4376 15.633 12.9984C15.633 11.5487 14.4492 10.3721 13.0013 10.3721C12.8744 10.3721 12.7476 10.3827 12.6314 10.4037C12.5891 11.5592 11.6379 12.4837 10.4647 12.4837H10.4118C10.3801 12.6517 10.359 12.8198 10.359 12.9984C10.359 14.4376 11.5427 15.6142 13.0013 15.6142Z",
  fill: "#B6B6B6"
});

function SvgShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.9bb52ce8.svg";
export { ForwardRef as ReactComponent };